import script from "./PromptSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromptSettings.vue?vue&type=script&setup=true&lang=ts"

import "./PromptSettings.scss?vue&type=style&index=0&id=53bd4e2e&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53bd4e2e"]])

export default __exports__